<template>
  <div>
    <el-row>
      <el-col class="box-card">

        <el-form ref="cardForm" :model="form" :rules="rules" label-position="top" class="form">
          <el-form-item prop="comment" class :error="error" label="Комментарий">
            <el-input
                name="comment"
                type="textarea"
                autosize
                ref="comment"
                v-model="form.comment"
                placeholder="Описание приема клиента"
            ></el-input>
          </el-form-item>

        </el-form>

      </el-col>
    </el-row>
    <el-row :gutter="5" class="btns">
      <el-button type="primary" name="sendForm" @click="sendForm" :loading="loadSend">Закрыть сессию</el-button>
    </el-row>
  </div>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "session.close",
  mounted() {
    this.$refs.comment.focus();
    if (window.localStorage.getItem('session.comment')) this.$set(this.form, 'comment', window.localStorage.getItem('session.comment'))
  },
  data() {
    return {
      form: {},
      rules: {
        comment: [
          {
            required: true,
            message: "Введите комментарий приема",
            trigger: "blur",
          },
        ],
      },
      error: null,
      loadSend: !!0,
    };
  },
  methods: {
    ...mapActions({
      sessionClose: "session/CLOSE"
    }),

    sendForm() {
      this.error = null;
      this.$refs.cardForm.validate((valid) => {
        if (valid) {
          this.loadSend = !!1;
          this.sessionClose(this.form)
              .then(() => {
                this.$notify.success({
                  title: "Удачно...",
                  message: "Сессия была закрыта",
                })

                this.$router.push({
                  name: "session.create",
                })

                if (window.localStorage.getItem('session.comment')) window.localStorage.removeItem('session.comment', '')
              })
              .catch((response) => {
                this.$notify.error({
                  title: "Ошибка закрытия сессии 😕",
                  message: response.response.data.message,
                });
              })
              .finally(() => {
                this.loadSend = !!0;
              });
        }
      });
    },
    goBack() {
      if (this.form.comment) window.localStorage.setItem('session.comment', this.form.comment)
      this.$router.push({name: "session.device"})
    }
  },
}
</script>

<style scoped lang="scss">
.box-card {
  max-width: 650px;
  border: 0;
  border-radius: 8px;
  box-shadow: none;
  padding: 10px;
  background: #fff;
  margin-left: 0;

}


.form {
  margin: 0 0 10px 0;
}

.btns {
  margin-top: 25px;
}
</style>
